/**
 * Dropio brand logo — uses the OFFICIAL uploaded master logo asset directly.
 *
 * The uploaded asset is the complete Dropio lockup (icon + wordmark).
 * It is rendered exactly as uploaded with preserved aspect ratio.
 * Do NOT recreate, redraw, recolor, modify proportions, modify spacing,
 * or alter the D shape, arrow, gradient, or dot above the i.
 *
 * Props:
 *   - size: number — rendered HEIGHT in pixels (width auto-scales to preserve aspect)
 *   - showText, variant: accepted for backward compatibility; no-op (the image IS the full lockup)
 */
const LOGO_URL = 'https://customer-assets.emergentagent.com/job_traveler-marketplace/artifacts/gg7kto6w_DROPIO%20Light%20version.png';

const DropioLogo = ({ size = 36, className = '', ...rest }) => {
  const { showText: _showText, variant: _variant, ...imgProps } = rest;

  return (
    <img
      src={LOGO_URL}
      alt="Dropio"
      height={size}
      style={{ height: size, width: 'auto', objectFit: 'contain', display: 'block' }}
      className={className}
      draggable={false}
      loading="eager"
      decoding="async"
      data-testid={rest['data-testid'] || 'dropio-logo'}
      {...imgProps}
    />
  );
};

export default DropioLogo;
